"use client";

import { useEffect, useState } from "react";

import RichText from "@/components/atoms/rich-text/rich-text";
import ActionButton from "@/components/molecules/action-button/action-button";
import { QuoteDecline } from "@/config/app-constant";
import { PRODUCT } from "@/constants";
import { MedicalDeclineContentType } from "@/utils/schema/quote-decline-schema.utils";

type QuoteDeclineProps = {
  unableToQuoteContent: MedicalDeclineContentType | null;
};

function RenewalMedicalDeclinedSection({
  unableToQuoteContent,
}: Readonly<QuoteDeclineProps>) {
  const [pageLoad, setPageLoad] = useState(false);

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      sessionStorage.getItem("PageReloadMedical") === "true"
    ) {
      history.pushState(null, "", location.href);
      window.onpopstate = function f() {
        const stringWithoutSlashes = window.location.pathname.replace(
          /\//g,
          ""
        );
        if (
          stringWithoutSlashes === QuoteDecline &&
          sessionStorage.getItem("PageReloadMedical") === "true"
        ) {
          history.go(1);
        } else {
          window.onpopstate = null;
          history.back();
        }
      };
    }
  }, []);

  useEffect(() => {
    setPageLoad(true);
    if (pageLoad) {
      if (sessionStorage.getItem("PageReloadMedical") === "true") {
        sessionStorage.setItem("PageReloadMedical", "false");
      } else {
        sessionStorage.setItem("PageReloadMedical", "true");
      }
    }
  }, [pageLoad]);

  if (!unableToQuoteContent) {
    return null;
  }

  const { declinedTitle, declinedContent, declinedCTAButton } =
    unableToQuoteContent;

  const handleContinue = () => {
    window.location.href = process.env.NEXT_PUBLIC_MY_ACCOUNT_URL!;
  };

  return (
    <div className="flex flex-col justify-start items-center md:pt-spacing-xl pt-spacing-m md:gap-spacing-xl gap-spacing-l relative md:min-h-[calc(100vh-188px)] min-h-[calc(100vh-96px)] px-spacing-m">
      <h1
        className={`text-center font-header-font md:text-5xl md:leading-[45px] text-[#fff] ${
          PRODUCT === "avanti" ? "lg:w-[690px] md:w-[558px]" : "md:w-[590px]"
        } w-[280px]  text-xl leading-[30px] break-words`}
      >
        {declinedTitle}
      </h1>
      <div
        className={`${
          PRODUCT === "avanti" ? "lg:w-[588px] md:w-[558px]" : "md:w-[530px] "
        } w-[280px]  p-spacing-m rounded-radius-lg border-solid border border-[#FFFFFF4D] bg-[#2724273D]`}
      >
        <RichText
          richText={declinedContent}
          className={`flex flex-col gap-spacing-s text-start font-body-font text-2xs leading-[24px] text-dark-text-body ${
            PRODUCT === "avanti" ? "[&>p>a]:text-surface-neutral-option-1" : ""
          }`}
        />
      </div>
      <div className="!p-0 md:w-[342px] w-[280px] mx-auto">
        <ActionButton
          page={QuoteDecline}
          showBackBtn={false}
          submitButtonClick={handleContinue}
          ctaButtonText={declinedCTAButton || ""}
        />
      </div>
    </div>
  );
}

export default RenewalMedicalDeclinedSection;
